import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './Box.styles';

const Box = ({ margin, children, style }) => (
  <Container margin={margin} style={style}>
    {children}
  </Container>
);

Box.propTypes = {
  children: PropTypes.node,
  margin: PropTypes.string,
  style: PropTypes.object
};

export default Box;
